<template>
    <el-input class="x-input"
        ref="input"
        :clearable="true"
        :type="config.inputType || 'text'"
        :model-value="content" 
        :disabled="readonly || config.readonly" 
        :placeholder="config.placeholder" 
        :maxlength="config.maxlength || 100" 
        :suffix-icon="config.icon"
        @focus="focusHandler"
        @blur="blurHandler"
        @update:modelValue="(value, oldvalue)=> update(value)"
    >
        <template v-if="config?.unit" #append>{{config?.unit}}</template>
    </el-input>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

const focused = ref(false);

const formatPrecision = (value, precision)=> {
    if (value == null) {} else {
        if (precision) {
            value = parseFloat(value);
            if (isNaN(value)) return;
            value = value.toFixed(precision);
            value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return value;
        }
    }
    return value;
}

const content = ref(props.config?.value != null ? props.config?.value + "" : null);
watch(()=> props.modelValue, (value, oldValue)=> {
    if (value == null && props.config?.value != null) value = formatPrecision(props.config?.value, props.config?.precision);
    // content.value = formatPrecision(props.modelValue, props.config?.precision);
    if (oldValue == null && content.value == null && !focused.value) {
        content.value = formatPrecision(props.modelValue, props.config?.precision);
    } else {
        content.value = value;
    }
}, {immediate:true})
// watch(()=> props.modelValue, (value, oldValue)=> {
//     content.value = value;
// })

const update = (value)=> {
    // if (props.config?.precision) {
    //     if (value) {
    //         value = parseFloat(value);
    //         value = value.toFixed(props.config.precision);
    //     }
    // }
    inst.emit('update:modelValue', value)
}

const focusHandler = ()=> {
    focused.value = true;
    if (props.config.precision) {
        let value = props.modelValue;
        if (value == null) {} else {
            value = parseFloat(value).toFixed(props.config.precision);
            value = value.replace(/\,/g, '');
            value = parseFloat(value);
            if (isNaN(value)) return;
            content.value = value;
        }
    }
}
const blurHandler = ()=> {
    if (props.config.precision) {
        let value = parseFloat(content.value);
        if (value == null) {} else {
            content.value = formatPrecision(value, props.config?.precision);
        }
        inst.emit('update:modelValue', value ? value.toFixed(props.config?.precision) : null);
    }
    focused.value = false;
}

defineEmits({
    'update:modelValue': null,
})
</script>
<!-- 组件注释（oneid：pcode+项目+标识（事件，数据）+ uuid）
     页面个性化融合
-->
